import { Link, H5 } from '@ppay/client'

export const Website = ({ value, className = '' }: { value: string; className?: string }) => (
  <H5 className={`m-0 ${className}`}>
    <Link target="_blank" href={'https://' + value}>
      {value}
    </Link>
  </H5>
)
